import React from 'react';
import styles from './Stats.module.css';

export default function Stats() {
    return (
        <section className={styles.statsSection}>
            <div className={styles.container}>
                <div className={styles.grid}>
                    <div>
                        <div className={styles.statValue}>300+</div>
                        <div className={styles.statLabel}>
                            VR Modules
                        </div>
                    </div>
                    <div>
                        <div className={styles.statValue}>100+</div>
                        <div className={styles.statLabel}>
                            Learning hours
                        </div>
                    </div>
                    <div>
                        <div className={styles.statValue}>100%</div>
                        <div className={styles.statLabel}>
                            Offline
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}
